module.exports = __webpack_public_path__ + "img/dsa_logo.242d5bfc.png";